module.exports = __webpack_public_path__ + "assets/img/1506_01.jpg?e4a71dadf2f98f98e6e4be3dddb8eb60";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1506_01.jpg
// module id = 1086
// module chunks = 0